// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/banner-favorite.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #13334c;
}

::-webkit-scrollbar-thumb:hover {
  background: #1e4f74;
}

.dot-span {
  color: #13334c;
  font-size: 2rem;
}

.navbar-bg {
  background-color: #13334c !important;
}

.jumbotron-background {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
  color: white;
  height: 500px;
  padding-top: 100px;
  padding-bottom: 100px;
  background-position: center 100%;
}

.jumbotron-background__favorite {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: cover;
  color: white;
  height: 500px;
  padding-top: 100px;
  padding-bottom: 100px;
  background-position: center 5%;
}

.jumbotron {
  margin-top: 100px;
}

.w-color {
  color: #19a7ce;
}

.w-bg {
  background-color: #13334c;
  width: 100%;
}

.detail {
  margin-top: 20px;
}

.img__fluid img {
  margin-top: 20px;
  width: 1000px;
  height: 400px;
  object-fit: cover;
}

.deskripsi-destinasi {
  margin-top: 20px;
}

.favorite {
  font-size: 18px;
  position: fixed;
  bottom: 16px;
  right: 16px;
  background-color: #db0000;
  color: white;
  border: 0;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  min-width: 44px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;mEAC4D;EAC5D,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE;mEACqE;EACrE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB","sourcesContent":["::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #13334c;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #1e4f74;\n}\n\n.dot-span {\n  color: #13334c;\n  font-size: 2rem;\n}\n\n.navbar-bg {\n  background-color: #13334c !important;\n}\n\n.jumbotron-background {\n  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url('../public/images/banner.png') no-repeat center center;\n  background-size: cover;\n  color: white;\n  height: 500px;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  background-position: center 100%;\n}\n\n.jumbotron-background__favorite {\n  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url('../public/images/banner-favorite.png') no-repeat center center;\n  background-size: cover;\n  color: white;\n  height: 500px;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  background-position: center 5%;\n}\n\n.jumbotron {\n  margin-top: 100px;\n}\n\n.w-color {\n  color: #19a7ce;\n}\n\n.w-bg {\n  background-color: #13334c;\n  width: 100%;\n}\n\n.detail {\n  margin-top: 20px;\n}\n\n.img__fluid img {\n  margin-top: 20px;\n  width: 1000px;\n  height: 400px;\n  object-fit: cover;\n}\n\n.deskripsi-destinasi {\n  margin-top: 20px;\n}\n\n.favorite {\n  font-size: 18px;\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  background-color: #db0000;\n  color: white;\n  border: 0;\n  border-radius: 50%;\n  width: 55px;\n  height: 55px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  min-width: 44px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
